import React, {useState} from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'

export const Switch = (props) => {

    const [active, setActive] = useState((props.activeInit)?props.activeInit:false)

    function handleOnClick(){
      setActive(!active)
      props.onCLick(!active)
    }

    return (
      <div className={style.switch}>
          <div className={style.swithLabels}>
              <div className={(!active)?style.swithLabelActive:style.swithLabel} style={(props.styleVersion === 2)?(active)?{color: '#BED0E5'}:{color: '#304B6B'}:{}}>{props.firstOption}</div>
              <div className={(active)?style.swithLabelActive:style.swithLabel} style={(props.styleVersion === 2)?(!active)?{color: '#BED0E5'}:{color: '#304B6B'}:{}}>{props.secondOption}</div>
          </div>
          <button onClick={handleOnClick} className={style.swithButton} style={{justifyContent: (active)?'flex-end':'flex-start', backgroundColor: (props.styleVersion === 2)?'#BED0E5':''}}>
              <div className={style.switchHandle} style={(props.styleVersion === 2)?{backgroundColor: '#304B6B'}:{}}></div>
          </button>
      </div>
    )
}

Switch.defaultProps = {
  styleVersion: 1
}
